import { render, staticRenderFns } from "./RobotManagement.vue?vue&type=template&id=377a89a8&scoped=true&"
import script from "./RobotManagement.vue?vue&type=script&lang=js&"
export * from "./RobotManagement.vue?vue&type=script&lang=js&"
import style0 from "./RobotManagement.vue?vue&type=style&index=0&id=377a89a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377a89a8",
  null
  
)

export default component.exports